<template>
  <div class="maininfo">
    <NewsHot></NewsHot>
    <HotList></HotList>
    <InfoNews></InfoNews>
    <PublicService></PublicService>
    <IndustryData></IndustryData>
    <LiveBlogroll></LiveBlogroll>
  </div>
</template>
<script>
import NewsHot from './main/NewsHot.vue';
import HotList from './main/HotList.vue';
import InfoNews from './main/InfoNews.vue';
import PublicService from './main/PublicService.vue';
import IndustryData from './main/IndustryData.vue';
import LiveBlogroll from './main/LiveBlogroll.vue';

export default {
  name: "Main",
  components: {
    NewsHot,
    HotList,
    InfoNews,
    PublicService,
    IndustryData,
    LiveBlogroll
},
  data() {
    return {
      
    }
  },
  mounted() {
  },
  methods: {}
};
</script>
<style scoped>
.maininfo{
  position: relative;
  width: 1200px;
  margin: 13px auto 0;
}
</style>
